import React from "react";
import { Form, Dropdown } from "semantic-ui-react";
const DropdownFormField = props => {
  return (
    <Form.Field>
      <label>
        {props.label}
      </label>
      <Dropdown
        selection
        {...props.input}
        options={props.options}
        value={props.input.value}
        onChange={(param, data) => props.input.onChange(data.value)}
        placeholder={props.placeholder}
      />
    </Form.Field>
  );
};
export default DropdownFormField;



// WEBPACK FOOTER //
// ./src/components/semanticDropdown.jsx